
    <template>
      <div class="cool-container">
        <div class="cool-container_inner">
          <div class="profile">
              <a href="mailto:tyrese.makhubele@gmail.com">
                  <img src="../assets/Tyrese_No_Bg_8.png" alt="Profile Pic" class="profile-pic"/>
              </a>
          </div>
          <div class="name">
              Built with <i class="fa fa-heart" aria-hidden="true"></i>
              by <span class="highlight" @click.stop="openEmail">Tyrese</span>
              <br/> <span style="font-size: 13px; color: grey;">Built as a birthday gift</span>
          </div>
        </div>
      </div>
    </template>
    
    <script>
    export default {
        methods: {
        openEmail() {
            window.location.href = "mailto:tyrese.makhubele@gmail.com";
        }
        }
    }
    </script>
  
  
  <style scoped>
  .cool-container {
    margin-left: auto;
    margin-right: auto;
  }

  .cool-container_inner {
    display: flex;
    justify-content: center;
    align-items: center;
    gap: 20px;
    padding: 15px;
    border-radius: var(--border-radius-main);
    background-color: var(--base-100);
    cursor: pointer;
    box-shadow: rgba(0, 0, 0, 0.3) 0px 19px 38px, rgba(0, 0, 0, 0.22) 0px 15px 12px;
  }
  
  .profile-pic {
    width: 40px;
    height: 40px;
    border-radius: 50%;
    border: 3px solid var(--primary);
    /*
    box-shadow: inset 0px 0px 0px 3px white;
    */
    display: flex;
    justify-content: center;
    align-items: center;
  }
  
  
  .name {
    font-size: 16px;
  }

  .profile{
    display: flex;
    justify-content: center;
    align-items: center;

  }
  
  .highlight {
    color: var(--primary);
    cursor: pointer;
    font-weight: 500;
  }
  
  .highlight:hover {
    text-decoration: underline;
  }

  .fa{
     color: var(--primary);
  }
  </style>
  